export default {
  data() {
    return {
      channel: null,
    }
  },
  created() {
    this.connectSocket();
  },
  methods: {
    connectSocket() {
      if(this.channel) {
        //this.channel.unsubscribe();
        this.channel = null;
      }
      if(this.activeDialog) {
        this.channel = this.$echo.private(`chat.${this.activeDialog}`);
      }
    },
  },
  watch: {
    activeDialog(v, oldV) {
      console.log('activeDialog watch', v, oldV)
      if(v !== oldV) {
        this.connectSocket();
      }
    }
  }
}
